import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from './contexts/ThemeContext';
import Navbar from './components/Navbar';
import Breadcrumbs from './components/Breadcrumbs';

import Home from './pages/Home';
import Matches from './pages/Matches';
import MatchDetail from './pages/MatchDetail';
import Teams from './pages/Teams';
import Stadiums from './pages/Stadiums';
import StadiumDetail from './pages/StadiumDetail';
import Cities from './pages/Cities';
import CityGuide from './pages/CityGuide';
import TravelPlanner from './pages/TravelPlanner';
import ItineraryPlanner from './pages/ItineraryPlanner';
import FanMeetups from './pages/FanMeetups';
import Tickets from './pages/Tickets';
import Hotels from './pages/Hotels';
import Tours from './pages/Tours';
import CockpitDashboard from './pages/CockpitDashboard';
import Standings from './pages/Standings';
import News from './pages/News';
import GuidesIndex from './pages/GuidesIndex';
import GuideArticle from './pages/GuideArticle';
import PrivacyPolicy from './pages/PrivacyPolicy';
import About from './pages/About';
import Contact from './pages/Contact';
import AdSenseScript from './components/AdSenseScript';
import Footer from './components/Footer';

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 60 * 1000 } },
});

function App() {
  return (
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <Router>
            <div className="min-h-screen bg-background dark:bg-slate-950 text-on-background dark:text-slate-100 transition-colors duration-200 flex flex-col font-body">
              <AdSenseScript />
              <Navbar />
              <Breadcrumbs />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/matches" element={<Matches />} />
                <Route path="/matches/:id" element={<MatchDetail />} />
                <Route path="/teams" element={<Teams />} />
                <Route path="/stadiums" element={<Stadiums />} />
                <Route path="/stadiums/:slug" element={<StadiumDetail />} />
                <Route path="/cities" element={<Cities />} />
                <Route path="/cities/:slug" element={<CityGuide />} />
                <Route path="/travel-planner" element={<TravelPlanner />} />
                <Route path="/itinerary-planner" element={<ItineraryPlanner />} />
                <Route path="/fan-meetups" element={<FanMeetups />} />
                <Route path="/tickets" element={<Tickets />} />
                <Route path="/hotels" element={<Hotels />} />
                <Route path="/tours" element={<Tours />} />
                <Route path="/cockpit" element={<CockpitDashboard />} />
                <Route path="/standings" element={<Standings />} />
                <Route path="/news" element={<News />} />
                <Route path="/guides" element={<GuidesIndex />} />
                <Route path="/guides/:slug" element={<GuideArticle />} />
                <Route path="/what-is-soccer" element={<Navigate to="/guides/soccer-rules-world-cup-beginners" replace />} />
                <Route path="/soccer-history" element={<Navigate to="/guides/soccer-rules-world-cup-beginners" replace />} />
                <Route path="/soccer-rules" element={<Navigate to="/guides/soccer-rules-world-cup-beginners" replace />} />
                <Route path="/offside-rule" element={<Navigate to="/guides/soccer-rules-world-cup-beginners" replace />} />
                <Route path="/soccer-formations" element={<Navigate to="/guides/soccer-rules-world-cup-beginners" replace />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
              </Routes>
              <Footer />
            </div>
          </Router>
        </ThemeProvider>
      </QueryClientProvider>
    </HelmetProvider>
  );
}

export default App;
